import * as React from 'react'
import {
  BreadcrumbSectionContainer,
  BreadcrumbLink,
  BreadcrumSectionDesktopRow,
  BreadcrumSectionMobileRow,
  BreadcrumbSpan, BreadcrumbMobileLink, BreadcrumLinkSpan,
  IconWrapper
} from './BreadcrumbSection.elements'
import {ChevronLeftIcon} from "@components/Icons";

export type BreadcrumbSectionProps = {
  links: BreadcrumbLink[]
}

type BreadcrumbLink = {
  text: string
  link?: string
}

export const BreadcrumbSection: React.FunctionComponent<BreadcrumbSectionProps> = ({links}) => (
  <BreadcrumbSectionContainer>
    <BreadcrumSectionDesktopRow>
      {links.map((l, idx) => (
        <React.Fragment key={`${l.text}-${idx}`}>
          { l.link ?
            <BreadcrumbLink href={l.link}>{l.text}</BreadcrumbLink> :
            <BreadcrumbSpan dangerouslySetInnerHTML={{__html: `> ${l.text}`}} />
          }
        </React.Fragment>
        )
      )}
    </BreadcrumSectionDesktopRow>
    <BreadcrumSectionMobileRow>
      <BreadcrumbMobileLink href={"/"}>
        <IconWrapper>
          <ChevronLeftIcon />
        </IconWrapper>
        <BreadcrumLinkSpan>HOME</BreadcrumLinkSpan>
      </BreadcrumbMobileLink>
    </BreadcrumSectionMobileRow>
  </BreadcrumbSectionContainer>
)
